module.exports = __webpack_public_path__ + "img/newpartner3.9ae630b7.png";